@if (offer(); as o) {
  <div class="sav-om-backdrop" role="presentation">
    <button
      type="button"
      class="sav-om-backdrop-hit"
      aria-label="Close dialog"
      (click)="close()"
    ></button>
    <div class="sav-om-card" role="dialog" aria-modal="true" [attr.aria-label]="o.title">
      <button type="button" class="sav-om-close" (click)="close()" aria-label="Close">×</button>

      <div class="sav-om-body">
        <div class="sav-om-logo">
          <app-store-logo
            [logoUrl]="o.storeLogoUrl"
            [name]="o.storeName"
            loading="eager"
            decorative
          />
        </div>

        <div class="sav-om-store">{{ o.storeName }}</div>
        <h2 class="sav-om-title">{{ o.title }}</h2>

        @if (!o.isDeal && o.code) {
          <div class="sav-om-code">
            <span class="sav-om-code-value">{{ o.code }}</span>
            <button #copyBtn type="button" class="sav-om-copy" (click)="copyCode()">
              {{ copied() ? 'Copied!' : 'Copy' }}
            </button>
          </div>
          <p class="sav-om-hint">
            Copy and paste this code at
            <a
              class="sav-om-storelink"
              [href]="o.goUrl"
              target="_blank"
              rel="nofollow sponsored noopener"
              (click)="goToStore()"
              >{{ o.storeName }}</a
            >
          </p>
        } @else {
          <button #copyBtn type="button" class="sav-om-cta" (click)="goToStore()">
            Activate my deal
          </button>
          <p class="sav-om-hint">
            Just visit
            <a
              class="sav-om-storelink"
              [href]="o.goUrl"
              target="_blank"
              rel="nofollow sponsored noopener"
              (click)="goToStore()"
              >{{ o.storeName }}</a
            >
            to avail this offer.
          </p>
        }

        <p class="sav-om-expiry">Ends {{ o.expiryText }}</p>

        <div class="sav-om-actions">
          <button type="button" class="sav-om-ghost" (click)="close()">View all coupons</button>
          <button
            type="button"
            class="sav-om-ghost sav-om-ghost-pending"
            title="Coming soon"
            (click)="close()"
          >
            View all products
            <span class="sav-om-dot" aria-hidden="true"></span>
          </button>
        </div>
      </div>

      @if (o.detail) {
        <div class="sav-om-exclusions"><strong>Exclusions:</strong> {{ o.detail }}</div>
      }
    </div>
  </div>
}
